import vision1 from "../../assets/images/Introduction/vision1.webp";
import target01 from "../../assets/images/Introduction/target01.webp";
import tip_pc from "../../assets/images/Introduction/tip_pc.webp";
import { Divider } from "@mui/material";
import sp from "../../assets/images/Footer/sp.svg";
import mobib from "../../assets/images/Introduction/mobib.webp";

export default function Vision() {
  return (
    <div className="w-full">
      <div className="w-full flex flex-row items-center justify-center gap-1 md:gap-2 px-[20px] mt-5 md:mt-6 ">
        <div>
          <img src={sp} alt="mo" className="hidden md:block" />
        </div>
        <p className="text-[28px] md:text-[32px] text-[#053CC8] font-semibold">
          TẦM NHÌN & SỨ MỆNH
        </p>
      </div>
      <div className="w-full container mx-auto px-[20px] py-[20px] items-center flex flex-col gap-5 lg:flex-row-reverse">
        <div className="w-full relative">
          <img
            src={mobib}
            alt="vi1"
            className="w-full h-auto object-cover block md:hidden"
          />
          <img
            src={tip_pc}
            alt="no"
            className="hidden md:block w-full object-cover h-auto"
          />
          <div className="w-[178px] h-[177px] md:w-[278px] md:h-[278px] bg-intro rounded-custom1 absolute bottom-0 right-0 -z-10"></div>
        </div>
        <div className="flex flex-col gap-3 w-full">
          <div className="w-full flex flex-col gap-2">
            <div className="w-full flex gap-2 items-center">
              <img src={target01} alt="ta" />
              <p className="text-[24px] text-[#333333] font-semibold">
                Tầm nhìn
              </p>
            </div>
            <div>
              <p className="text-[16px] font-normal text-[#333333]">
                Trở thành giải pháp công nghệ hàng đầu dành cho giáo dục, đồng
                hành cùng sự phát triển của các trung tâm và trường học
              </p>
            </div>
          </div>
          <div className="w-full">
            <Divider sx={{ borderColor: "#E2E2E2" }} />
          </div>
          <div className="w-full flex flex-col gap-2">
            <div className="w-full flex gap-2 items-center">
              <img src={target01} alt="ta1" />
              <p className="text-[24px] text-[#333333] font-semibold">
                Sứ mệnh
              </p>
            </div>
            <div>
              <p className="text-[16px] font-normal text-[#333333]">
                Tại <spam className="text-[#053CC8] font-bold">Blue Rise</spam>,
                chúng tôi tin rằng công nghệ có thể thay đổi cách quản lý giáo
                dục. Sứ mệnh của chúng tôi là giúp các trung tâm giáo dục hiện
                đại hóa quy trình quản trị, nâng cao chất lượng dịch vụ và mang
                lại trải nghiệm học tập tốt nhất cho học viên. Chúng tôi hướng
                đến mục tiêu trở thành đối tác đáng tin cậy cho mọi trung tâm
                giáo dục, từ nhỏ đến lớn, bằng cách cung cấp nền tảng quản trị
                linh hoạt và toàn diện.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
